import axios from '../../axios';
import { toast } from 'react-toastify';
import {
   ADD_VOUCHER,
   GET_VOUCHER,
   UPDATE_VOUCHER,
   DELETE_VOUCHER,
   LAST_VOUCHER_DETAILS,
   GET_LAST_VOUCHER_DAYBOOK,
   GET_ONE_VOUCHER,
   PENDING_VOUCHER_DETAILS,
   ADD_OUT_ADJUSTMENT,
   ADJUSTMENT_VOUCHER_DETAILS,
   GET_ADJUSTED_VOUCHER,
   GET_BANK_VOUCHER,
   SET_PENDING_VOUCHER,
   UPDATE_VOUCHER_CLEARING_DATE,
   ADJUSTMENT_VOUCHER_BALANCE,
   ADD_OUT_ADJUSTMENTS,
   VOUCHER_PREV_NEXT,
   CHECK_LAST_DOC_NUMBER_VOUCHER,
   MULTI_DELETE_VOUCHER,
} from '../types';

export const getVoucher = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/voucher/all', { params });

      if (res.data.code === 1) {
         dispatch({
            type: GET_VOUCHER,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getBankVoucher = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/voucher/all', { params });

      if (res.data.code === 1) {
         dispatch({
            type: GET_BANK_VOUCHER,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
   } catch (err) {
      if (err.response.status === 500) {
         toast.error('Internam Server Error');
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getAdjustedVoucher = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/voucher/adjustment/already', { params });

      if (res.data.code === 1) {
         dispatch({ type: GET_ADJUSTED_VOUCHER, payload: res.data.data, totalCount: res.data.totalCount });
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const addVoucher = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/voucher/add', formData);

      if (res.data.code === 1) {
         dispatch({ type: ADD_VOUCHER, payload: res.data.data });
         setTimeout(() => {
            toast.success('Voucher added successfully!');
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400 && err.response.status === 500) {
         toast.error(err.response.data.message);
         return;
      } else {
         if (err.response.data.errors[0].message) {
            toast.error(err.response.data.errors[0].message);
            return;
         }
      }
   }
};

export const addOutAdjustment = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/outAdjustment/add', formData);

      if (res.data.code === 1) {
         dispatch({ type: ADD_OUT_ADJUSTMENT, payload: res.data.data });
         setTimeout(() => {
            toast.success('Outstanding Adjustment added successfully!');
         }, 1000);
      } else if (res.data.code === 2 || res.data.code === 0) {
         setTimeout(() => {
            toast.error(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.code === 2) {
         toast.error(err.response.data.message);
      } else if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const updateVoucher = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/voucher/update`, formData);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_VOUCHER, payload: res.data.data });

         setTimeout(() => {
            toast.success('Voucher updated successfully!');
         }, 1000);
      }

      if (res.data.code === 2) {
         setTimeout(() => {
            toast.error(res.data.message);
         }, 1000);
      }
      if (res.data.code === 0) {
         setTimeout(() => {
            toast.error(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.warn(err.response.data?.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};
export const updateClearingDate = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/voucher/update-clearing-date`, formData);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_VOUCHER_CLEARING_DATE, payload: res.data.data });

         setTimeout(() => {
            toast.success('Clearing Date Updated successfully!');
         }, 1000);
      }

      if (res.data.code === 2) {
         setTimeout(() => {
            toast.error(res.data.message);
         }, 1000);
      }
      if (res.data.code === 0) {
         setTimeout(() => {
            toast.error(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400 || err.response.status === 500) {
         toast.warn(err.response.data?.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const lastVoucherDetails = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/voucher/lastDocNumber`, {
         params,
      }); //pass Daybook ID and comp ID

      if (res.data.code === 1) {
         dispatch({
            type: LAST_VOUCHER_DETAILS,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const checkLastDocNumberVoucher = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`voucher/checkLastDocNumber`, formData);

      if (res.data.code === 1) {
         dispatch({
            type: CHECK_LAST_DOC_NUMBER_VOUCHER,
            payload: res.data.data,
         });
      }
      if (res.data.code === 1) {
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const pendingVoucherDetails = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/voucher/pending`, {
         params,
      }); //pass account ID and comp ID

      if (res.data.code === 1) {
         dispatch({
            type: PENDING_VOUCHER_DETAILS,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};
export const adjustmentEditVoucherDetails = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/voucher/adjustment`, {
         params,
      }); //pass account ID and comp ID
      if (res.data.code === 1) {
         dispatch({
            type: ADJUSTMENT_VOUCHER_DETAILS,
            payload: res.data.data.voucher,
         });
         dispatch({
            type: ADJUSTMENT_VOUCHER_BALANCE,
            payload: res.data.data.balance,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};
export const voucherNextPrev = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/voucher/prev-next`, {
         params,
      }); //pass account ID and comp ID
      if (res.data.code === 1) {
         dispatch({
            type: VOUCHER_PREV_NEXT,
            payload: res.data.data,
         });
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

// Get Last Voucher Daybook

// Delete Voucher
export const deleteVoucher = (id) => async (dispatch) => {
   try {
      if (!id) {
         toast.error('Please select any record');
         return false;
      }
      const res = await axios.post(`/voucher/delete/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_VOUCHER, payload: { id } });
         toast.success('Voucher Deleted successfully');
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const multiDeleteVoucher = (deleteData) => async (dispatch) => {
   try {
      if (!deleteData || !deleteData.voucherIds || deleteData.voucherIds.length === 0) {
         toast.error('Please select any record');
         return false;
      }

      const res = await axios.post(`/voucher/delete/multi`, deleteData);

      if (res.data.code === 1) {
         dispatch({
            type: MULTI_DELETE_VOUCHER,
            payload: { voucherIds: deleteData.voucherIds },
         });
         toast.success('Vouchers Deleted successfully');
      }
   } catch (err) {
      if (err.response?.data?.errors?.[0]?.message) {
         toast.error(err.response.data.errors[0].message);
      } else {
         toast.error('Failed to delete vouchers');
      }
   }
};

export const getOneVoucher = (id) => async (dispatch) => {
   try {
      if (!id) {
         toast.error('Please select any record');
         return false;
      }
      // const res = await axios.get('/voucher/id', { id });
      const res = await axios.get(`/voucher/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: GET_ONE_VOUCHER, payload: res.data.data, single: res.data.data });
         return res.data;
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

// Add this to your voucher actions file
export const clearPendingVoucher =
   (data = []) =>
   (dispatch) => {
      try {
         dispatch({
            type: SET_PENDING_VOUCHER,
            payload: data,
         });
      } catch (err) {
         console.error('Error setting pending voucher data:', err);
      }
   };

export const addManyOutAdjustments = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/outAdjustment/addMany', formData);

      if (res.data.code === 1) {
         dispatch({ type: ADD_OUT_ADJUSTMENTS, payload: res.data.data });
         setTimeout(() => {
            toast.success('Out Adjustments added successfully!');
         }, 1000);
      } else if (res.data.code === 2 || res.data.code === 0) {
         setTimeout(() => {
            toast.error(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400 && err.response.status === 500) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};
